import React from 'react';

const TargetDisplay = () => {
	return (
		<div id="target-indicator" className="target-indicator">
			<div className="limits">
				<span className="lsl"><span className="label">LSL</span><span className="value">725</span></span>
				<span className="usl"><span className="label">USL</span><span className="value">775</span></span>
			</div>
			<div className="target">
				<p>
					<span className="label">Target Thrust</span>
					<span className="value">750</span>
				</p>
			</div>
		</div>
	);
}

export default TargetDisplay;